import type { TurnProgressStage } from '@salescore/agent-contract'

// 考え中の欄に出す文言を、runtime の progress の段階と、指示を送ってから最初のイベントを待った時間で決める。
// 段階の一覧と文言、待ち時間の扱いの正本は salescore-agent-docs の arch/api/progress.md にある

// このタブで送ったターンで、runtime の最初のイベントを待っている間だけ持つ。
// 途中からの配信でつないだターンには progress が届かないので持たず、「考え中」を出す
export interface TurnWaiting {
  // 指示を送った時刻（ISO 8601）
  sentAt: string
  // セッションの最初の指示か。runtime は必ず Codex を起動して待ち時間が長いので、送った直後から「接続しています」を出す
  isFirstTurn: boolean
}

// 段階のほかに、runtime の最初のイベントを待っている間の「接続しています」がある
export type ThinkingLabel = TurnProgressStage | 'connecting'

// 既にあるセッションで、送ってからこの時間がたってもイベントが届かなければ「接続しています」に切り替える。
// その前にイベントが届けば切り替えない。1秒は仮の値で、dev1 で測って見直す（arch/api/progress.md）。
const CONNECTING_LABEL_DELAY_MS = 1000

export const thinkingLabelOf = (
  stage: TurnProgressStage | null,
  waiting: TurnWaiting | null,
  now: number,
): ThinkingLabel => {
  if (stage !== null) {
    return stage
  }
  if (waiting === null) {
    return 'thinking'
  }
  return waiting.isFirstTurn || now - Date.parse(waiting.sentAt) >= CONNECTING_LABEL_DELAY_MS
    ? 'connecting'
    : 'thinking'
}

// 「考え中」から「接続しています」に切り替わるまでの時間（ms）。段階が届いた、待っていない、もう切り替わっていれば null
export const msUntilConnectingLabel = (
  stage: TurnProgressStage | null,
  waiting: TurnWaiting | null,
  now: number,
): number | null => {
  if (stage !== null || waiting === null || waiting.isFirstTurn) {
    return null
  }
  const remaining = Date.parse(waiting.sentAt) + CONNECTING_LABEL_DELAY_MS - now
  return remaining > 0 ? remaining : null
}
